const thirdPartyProviderPartner = {
  VTEX: 'VTEX'
};

module.exports = thirdPartyProviderPartner;
